import { ProjectInterface } from "@/modules/projects/types";

export const canCreateProjectRole = (
  project: Pick<ProjectInterface, "editable"> | undefined
): boolean => {
  return Boolean(project?.editable);
};
